(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitacaoDesenvolvimentoController', SolicitacaoDesenvolvimentoController);

    SolicitacaoDesenvolvimentoController.$inject = ['$scope', '$state', 'SolicitacaoDesenvolvimento', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function SolicitacaoDesenvolvimentoController($scope, $state, SolicitacaoDesenvolvimento, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filtro = "";


        loadAll();

        function loadAll() {
            SolicitacaoDesenvolvimento.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.solicitacaoDesenvolvimentos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse SolicitacaoDesenvolvimento?", "warning", function () {
                SolicitacaoDesenvolvimento.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O SolicitacaoDesenvolvimento foi removido!");
                        loadAll();
                    });
            });
        }
    }
})();
